import { CSSProperties, memo, useMemo } from 'react'
import { Settings } from 'lucide-react'

export const ShortcutIcon: React.FC<{ size?: number; image?: string; extension?: string; style?: CSSProperties }> =
  memo(({ image, extension, size, style }) => {
    if (!image || !extension) {
      return <Settings size={size ?? 24} />
    }

    const imageStyle = useMemo(() => {
      return {
        ...style,
        width: `${size ?? 24}px`,
        height: `${size ?? 24}px`,
      }
    }, [size, style])

    return (
      <img
        className={'pointer-events-none select-none rounded-full'}
        src={`https://ykwkqpmethjmpimvftix.supabase.co/storage/v1/render/image/public//user_content/${image}.${extension}?width=128&height=128&quality=75`}
        alt={extension}
        style={imageStyle}
      />
    )
  })
